// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ConciergeModal .ConciergeModalContainer {
  display: block !important;
}
.ConciergeModal .ConciergeModalContainer .title {
  font-weight: 600;
  font-size: 24px !important;
  line-height: none !important;
  font-style: normal;
}
.ConciergeModal .ConciergeModalContainer .sub-title {
  text-align: left;
  margin-top: -8px;
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 25px;
  /* or 112% */
  letter-spacing: -0.01em;
  margin-bottom: 31px;
}
.ConciergeModal .ConciergeListContainer {
  display: flex !important;
  border-top: 1px solid #cfcdcd;
}
.ConciergeModal .itemLeft {
  padding-top: 25px;
  padding-bottom: 15px;
  width: 15%;
  font-weight: bold;
  font-size: 17px;
}
.ConciergeModal .itemRight {
  font-family: "FKGroteskNeue-Regular";
  padding-top: 28px;
  padding-bottom: 28px;
  width: 80%;
  font-weight: 500;
  font-size: 20px;
  line-height: 24px;
  color: #000;
  text-decoration: none;
}`, "",{"version":3,"sources":["webpack://./src/containers/ChooseAFlight/ConciergeModal/ConciergeModal.scss","webpack://./src/styles/variables.scss"],"names":[],"mappings":"AAGE;EACE,yBAAA;AAFJ;AAGI;EACE,gBAAA;EACA,0BAAA;EACA,4BAAA;EACA,kBAAA;AADN;AAGI;EACE,gBAAA;EACA,gBAAA;EAEA,kBAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EAEA,YAAA;EACA,uBAAA;EACA,mBAAA;AAHN;AAME;EACE,wBAAA;EACA,6BAAA;AAJJ;AAME;EACE,iBAAA;EACA,oBAAA;EACA,UAAA;EACA,iBAAA;EACA,eAAA;AAJJ;AAME;EACE,oCCnBW;EDoBX,iBAAA;EACA,oBAAA;EACA,UAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,WAAA;EACA,qBAAA;AAJJ","sourcesContent":["@use \"src/styles/variables\" as vars;\n\n.ConciergeModal {\n  .ConciergeModalContainer {\n    display: block !important;\n    .title {\n      font-weight: 600;\n      font-size: 24px !important;\n      line-height: none !important;\n      font-style: normal;\n    }\n    .sub-title {\n      text-align: left;\n      margin-top: -8px;\n\n      font-style: normal;\n      font-weight: 500;\n      font-size: 18px;\n      line-height: 25px;\n\n      /* or 112% */\n      letter-spacing: -0.01em;\n      margin-bottom: 31px;\n    }\n  }\n  .ConciergeListContainer {\n    display: flex !important;\n    border-top: 1px solid vars.$grey2;\n  }\n  .itemLeft {\n    padding-top: 25px;\n    padding-bottom: 15px;\n    width: 15%;\n    font-weight: bold;\n    font-size: 17px;\n  }\n  .itemRight {\n    font-family: vars.$font-regular;\n    padding-top: 28px;\n    padding-bottom: 28px;\n    width: 80%;\n    font-weight: 500;\n    font-size: 20px;\n    line-height: 24px;\n    color: #000;\n    text-decoration: none;\n  }\n}\n","$page-width: 968px;\n$page-short-width: 700px;\n$black: #000;\n$white: #fff;\n$yellow: #ebff0c;\n$blue: #3881ef;\n$blue1:#4782E7;\n$red: #ef3838;\n$dark-blue: #1d6add;\n$grey1: #f1f4f9;\n$grey2: #cfcdcd;\n$grey3: #848b94;\n$grey4: #d5dce7;\n$grey5: #2c3034;\n$grey6: #535a61;\n$grey7: #9ca2a9;\n$grey8: #666d74;\n\n$font-regular: 'FKGroteskNeue-Regular';\n$font-medium: 'FKGroteskNeue-Medium';\n$font-bold: 'FKGroteskNeue-Bold';\n$mobile-media: 'max-width: 451px';\n$tablet-media-min: 'min-width: 451px';\n$tablet-media: 'max-width: 800px';\n$tablet-media-min-hz: 'min-width: 800px';\n$tablet-media-hz: 'max-width: 1200px';\n\n// Guide Color Code ----------------------------------\n\n$primary-black: #000000;\n$primary-white: #FFFFFF;\n$primary-gray: #F1F4F9;\n$secondary-yellow: #EBFF0C;\n$secondary-skyblue: #3881EF;\n$secondary-darkblue: #1D6ADD;\n$light-gray1: #F1F4F9;\n$light-gray2: #D5DCE7;\n$light-gray3: #848B94;\n$dark-gray1: #2C3034;\n$dark-gray2: #535A61;\n$dark-gray3: #9CA2A9;\n$error-red: #EF3838;\n$success-green : #AAFE3F;\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
